var exports = {
  "qb": "xe533113f--f2d2d5--skeleton-item",
  "nV": "xe533113f--f2d2d5--gallery",
  "AD": "xe533113f--f2d2d5--gallery--wide",
  "jW": "xe533113f--f2d2d5--photo",
  "_4": "xe533113f--f2d2d5--thumbnails",
  "t$": "xe533113f--f2d2d5--publisher",
  "my": "xe533113f--f2d2d5--avatar",
  "UU": "xe533113f--f2d2d5--name",
  "$H": "xe533113f--f2d2d5--agent-type",
  "Qs": "xe533113f--f2d2d5--content",
  "WD": "xe533113f--f2d2d5--labels",
  "DD": "xe533113f--f2d2d5--title",
  "q9": "xe533113f--f2d2d5--price",
  "VA": "xe533113f--f2d2d5--subtitle",
  "QY": "xe533113f--f2d2d5--geo",
  "hl": "xe533113f--f2d2d5--address",
  "Uo": "xe533113f--f2d2d5--buttons",
};

module.exports = exports;
